import { render, staticRenderFns } from "./ProbeDataTable.vue?vue&type=template&id=bb526f9e"
import script from "./ProbeDataTable.vue?vue&type=script&lang=js"
export * from "./ProbeDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports